import React from "react";

class Page1 extends React.Component {
  state = {
    visible: true,
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 1) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  render() {
    return (
      <div>
        {this.state.visible ? (
          <div className="container-fluid h-100 vertical-center ">
            <div className="row h-100 justify-content-center">
              <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                <div className="card mb-4 box-shadow" id="pageContent">
                  <div className="card-body d-flex flex-column text-dark">
                    <span id="moduleContentText_2">
                      <p>
                        {" "}
                        Fantastic! You seem to be pretty sorted. Career
                        management is a lifelong process and in ‘doing the job’
                        it is easy to lose sight of the importance of building
                        relationships. At the heart of any positive working
                        relationship lies emotional intelligence.
                      </p>

                      <p className="text-margin-left">
                        Do you know someone or would like to be known as someone
                        who is adept at managing their emotions. Someone who
                        stays calm under pressure and has the ability to look at
                        a problem calmly and find a solution. Someone who is a
                        confident decision maker whilst being open to feedback?
                      </p>
                      <p>
                        People like this have a high degree of emotional
                        intelligence. They know themselves very well, and
                        they're also able to sense the emotional needs of
                        others. Although you are sorted with regards to your
                        next steps, we thought you might find it helpful to
                        think about ways you can continue to develop.
                      </p>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page1;
